import React from "react";
import AppBar from "../components/commons/AppBar";
import Footer from "../components/commons/Footer";
// import useStyles from "../styles/privateLayoutStyle";
import MenuList from '@/components/layout/Menu';
import {useGlobalState} from '@/GlobalProvider';
import {makeStyles} from '@material-ui/core';


import "../css/commonLayout.scss"

const footHeight = 64;
const useStyles = makeStyles((theme) => ({
  root: {
    background: "#f8f9fc",
    position: "relative",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  contentBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    height: `calc( 100vh - ${footHeight}px)`,
    // paddingTop: theme.spacing(8),
  },
  drawer: {
    width: "240px"
  },
  content: {
    paddingTop: theme.spacing(8),
    flex: 1,
  },
  rightBox: {
    flex: 1,
    boxSizing: "border-box",
    padding: theme.spacing(2),
    // marginLeft: drawerWidth,
    height: "100%",
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  }
}));

const CommonLayout = (props) => {
  const classes = useStyles();
  const { menuFixedOpen } = useGlobalState()
  return (
    <div className={classes.root}>
      {props.showToolBar !== false && <AppBar />}
      <div className={classes.content}>
        <div className={`${classes.contentBox} my-common-layout-root ${!menuFixedOpen ? ' ' : 'hideMenu'}`}>
          <nav className={`${classes.drawer} my-menu-box`} aria-label="mailbox folders">
            <MenuList />
          </nav>
          <main className={classes.rightBox}>
            {props.children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;
